import useDictionary from '../../dictionaries/context/useDictionary';
import { getSpace } from '../getSpace/getSpace';
import { GroupName } from '../types/GroupName';
import { SpaceName } from '../types/SpaceName';
import { addTextToSpace } from './addTextToSpace';
import { useSpaceContext, UseSpaceContext } from './useSpaceContext';

/**
 * Hook for auto connection of space to implementation to default contexts
 * @param groupName
 * @param spaceName
 * @param context
 * @returns
 */
export const useSpace = (
  groupName: GroupName,
  spaceName: SpaceName,
  context: UseSpaceContext,
) => {
  const spaceContext = useSpaceContext(context);
  const { gT, dictionary } = useDictionary();

  const extra = { gT, dictionary };
  const space = getSpace(groupName, spaceName, spaceContext, extra);

  return addTextToSpace(space, spaceContext, gT);
};
